"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkInfo = {
    host: 'npmjs.com',
    version: '6.2.0',
    name: 'kentico-cloud-delivery'
};
//# sourceMappingURL=sdk-info.generated.js.map


// WEBPACK FOOTER //
// ./node_modules/kentico-cloud-delivery/_commonjs/sdk-info.generated.js